import { render, staticRenderFns } from "./AnexosViewDlg.vue?vue&type=template&id=5c75b357"
import script from "./AnexosViewDlg.vue?vue&type=script&lang=js"
export * from "./AnexosViewDlg.vue?vue&type=script&lang=js"
import style0 from "./AnexosViewDlg.vue?vue&type=style&index=0&id=5c75b357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports